<div class="box">
  <div class="box-row header">
    <app-header-bar [title]="'user.title'"></app-header-bar>
  </div>
  <div class="box-row content mt-2">
    <div class="row w-100">
      <app-reusable-tabs
        [tabConfig]="tabsConfig">
      </app-reusable-tabs>

      <ng-template #managerTabContent>
        <app-user [showAdminActions]="showAdminActions"></app-user>
      </ng-template>

      <ng-template #workerTabContent>
        <app-worker></app-worker>
      </ng-template>
    </div>
  </div>
</div>
